import App from 'app/App';
import { createRoot } from 'react-dom/client';
import 'regenerator-runtime/runtime';
import DebugSetup from 'utils/debug/Setup';
import { initSentry } from 'utils/sentry';

import { setServiceName } from '@hh.ru/front-static-app';

setServiceName('clickme');

initSentry();
DebugSetup.install();
window.globalVars = {};
window.globalVars.analyticsParams = {};

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
